module.exports = __webpack_public_path__ + "static/media/closeButton.d16064ab.svg";